import React from 'react';
import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil'
import App from './App';
import { BrowserRouter,Routes,Route } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RecoilRoot>
    <BrowserRouter>
      <Routes>
        <Route path="/"exact element={ <App />}></Route>
        <Route path="/resumo" element={ <App />  }></Route>
        <Route path="/projetos" element={ <App />  }></Route>
        <Route path="/contatos" element={ <App />  }></Route>
      </Routes>
    </BrowserRouter>
  </RecoilRoot>
);

